import { Declaration } from 'store/declarations/declaration';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { getIrelandProductsTotalByDeclarationId } from 'store/products/client';

export type ProductsTotalRequest = (declarationId: string) => Promise<number | undefined>;
export type GetCurrencyRequest = (declaration: Declaration | undefined) => string | undefined;

type ProductsTotalConfig = {
    request: ProductsTotalRequest;
    getCurrency: GetCurrencyRequest;
};

const productsTotalRequests: Partial<
    Record<DeclarationCountry, Partial<Record<DeclarationInternalType, ProductsTotalConfig>>>
> = {
    [DeclarationCountry.IRELAND]: {
        [DeclarationInternalType.IMPORT]: {
            request: getIrelandProductsTotalByDeclarationId,
            getCurrency: (declaration) => declaration?.irelandImportDeclaration?.invoiceCurrency,
        },
    },
};

export const getProductsTotalConfig = (
    country: string | undefined,
    internalType: string | undefined
): ProductsTotalConfig | undefined => {
    if (!country || !internalType) return undefined;

    const config = productsTotalRequests[country as DeclarationCountry];

    return config?.[internalType as DeclarationInternalType];
};
